// app/lib/api/services/subscription.ts

import { BASE_URL, createHeaders, log } from '../utils';
import { CheckoutRequest, SubscriptionTier, BillingCycle, SubscriptionInfo } from '../types';

export async function createCheckoutSession(tier: SubscriptionTier, billing_cycle: BillingCycle) {
  const headers = await createHeaders();
  log('Creating checkout session');
  
  // Get Tolt referral ID from the window object if available
  const toltReferral = typeof window !== 'undefined' ? (window as any).tolt_referral : null;
  
  const requestBody: CheckoutRequest = {
    tier,
    billing_cycle,
    referral: toltReferral || ""
  };

  const response = await fetch(`${BASE_URL}/create-checkout-session`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(requestBody)
  });

  if (!response.ok) {
    const error = `Request failed with status ${response.status}`;
    log('Checkout session creation error', error);
    throw new Error(error);
  }

  const data = await response.json();
  return data.sessionId;
}

export async function createCancellationSession() {
  const headers = await createHeaders();
  console.log('Creating cancellation session');

  try {
    const response = await fetch(`${BASE_URL}/create-cancellation-session`, {
      method: 'POST',
      headers: headers,
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const data = await response.json();
    console.log('Received data:', data);

    if (typeof data === 'string' && data.startsWith('http')) {
      return data;
    } else if (data && data.url) {
      return data;
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error('Error in createCancellationSession:', error);
    throw error;
  }
}

export async function getUserSubscriptionInfo(): Promise<SubscriptionInfo> {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/get-user-subscription-info`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function hasUserPaid() {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/has-user-paid`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data.has_paid;
}
